import { Autocomplete, TextField } from '@mui/material';
import { addDays, getUnixTime } from 'date-fns';
import React from 'react';
import { AccessKeyExpiration } from 'types/accessKeys';

interface IAccessKeyExpirationFieldProps {
	formik: any;
	id: string;
	defaultExpiration?: AccessKeyExpiration;
}

const AccessKeyExpirationField: React.FC<IAccessKeyExpirationFieldProps> = ({
	formik,
	id,
	defaultExpiration
}) => (
	<Autocomplete
		data-testid="access-keys-expiration-autocomplete"
		id="access-keys-expiration"
		options={[
			AccessKeyExpiration.thirty,
			AccessKeyExpiration.sixty,
			AccessKeyExpiration.ninety,
			AccessKeyExpiration.never
		]}
		defaultValue={defaultExpiration}
		getOptionLabel={(option) => intl.tr(`accessKeys.expiration.${option}`)}
		onChange={async (_, v) => {
			let res = v;
			if (v) {
				res = getUnixTime(addDays(new Date(), v));
			}
			await formik.setFieldValue(id, res);
		}}
		renderInput={(params) => (
			<TextField
				{...params}
				label={intl.tr('accessKeys.action.add.dialog.fields.expireTime')}
				fullWidth
			/>
		)}
	/>
);

AccessKeyExpirationField.defaultProps = {
	defaultExpiration: AccessKeyExpiration.thirty
};

export default AccessKeyExpirationField;
